import { getNestedProperty } from '@opallabs/lambda'
import { State } from '../../../types'
import { registerAction } from '../../Action'

const REMOVE_ASSIGNED_USER = 'REMOVE_ASSIGNED_USER'

type Action = {
  type: 'REMOVE_ASSIGNED_USER'
  payload: string
}
type Reducer = (state: State, action: Action) => State

const reducer: Reducer = (state, action) => {
  const assignmentId = action.payload
  const assignment = getNestedProperty(
    state,
    'jsonApiEntities',
    'assignment',
    assignmentId
  )
  if (!state.jsonApiEntities || assignment === undefined) return state

  const assignmentRelationsips = { ...assignment.relationships }
  delete assignmentRelationsips.assigned_user

  return {
    ...state,
    jsonApiEntities: {
      ...state.jsonApiEntities,
      assignment: {
        ...state.jsonApiEntities.assignment,
        [assignmentId]: {
          ...assignment,
          relationships: assignmentRelationsips,
        },
      },
    },
  }
}

const removeAssignedUser = registerAction(REMOVE_ASSIGNED_USER, { reducer })

export default removeAssignedUser
